/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2024-01-14 12:05:35
 * @LastEditTime: 2024-05-31 16:50:59
 * @Description: 
 */
import React, { useEffect, useState } from "react";
import Header from '../components/Header';
import Nav from '../components/Nav';
import '../i18n/i18n'
import Footer from '../components/Footer';
import ReactGA from 'react-ga4';
import "../css/GoodChannelPosts.css";
import api from "../services/api";
import { useNavigate } from "react-router-dom";


const GoodChannel = () => {

  useEffect(() => {
    document.title = "Good Club - GoodChannel"
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname ,title : 'Good Club - GoodChannel'});
  }, []);

  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  let fetching = false;

  const fetchPosts = async (page) => {
    if (fetching) return; // Avoid duplicate calls

    try {
      fetching = true;
      setIsLoading(true);
      const response = await api.get(`/auth/getExplore/${page}`);
      if (response.data.explores.length > 0) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.explores]);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      fetching = false;
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(currentPage);
    // eslint-disable-next-line 
  }, [currentPage]);


  const loadMorePosts = () => {
    if (hasMore && !isLoading) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePostClick = (exploreId) => {
    navigate(`/post/${exploreId}`); // Navigate to the Post page with the exploreId
  };

  return (
    <div>
      <Header />
      <Nav />

      <div className="good-channel-posts-container">
      <div className="good-channel-posts-content">
        <div className="good-channel-grid">
          {posts.map((post) => (
            <div key={post.exploreId}
              className="good-channel-card"
              onClick={() => handlePostClick(post.exploreId)} // Add click handler
              style={{ cursor: "pointer" }} // Change cursor to pointer
            >
              <img
                src={post.exploreImages}
                alt={post.exploreTitle}
                className="good-channel-image"
              />
              <div className="good-channel-info">
                <h3 className="good-channel-card-title">{post.exploreTitle}</h3>
                <p className="good-channel-card-content">
                  {post.exploreContent.length > 100
                    ? `${post.exploreContent.slice(0, 100)}...`
                    : post.exploreContent}
                </p>
              </div>
            </div>
          ))}
        </div>
        {hasMore && (
          <div className="good-channel-button-container">
            <button
              className="good-channel-button"
              onClick={loadMorePosts}
              disabled={isLoading}
            >
              {isLoading ? "加載中..." : "加載更多"}
            </button>
          </div>
        )}
      </div>
    </div>
      <Footer />
    </div>
  );
};

export default GoodChannel;


